const REPORT_TIME_ZONE = 'Asia/Colombo';

const pad = (value: number) => value.toString().padStart(2, '0');

export const getReportToday = (date: Date = new Date()): string => {
  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone: REPORT_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }).formatToParts(date);
  const values = Object.fromEntries(parts.map(part => [part.type, part.value]));

  return `${values.year}-${values.month}-${values.day}`;
};

export const getReportMonth = (date: Date = new Date()): string => getReportToday(date).slice(0, 7);

export const getReportWeekRange = (dateValue: string = getReportToday()): { start: string; end: string } => {
  const [year, month, day] = dateValue.split('-').map(Number);
  const date = new Date(Date.UTC(year, month - 1, day));
  const daysSinceMonday = (date.getUTCDay() + 6) % 7;
  const monday = new Date(date);
  monday.setUTCDate(date.getUTCDate() - daysSinceMonday);
  const sunday = new Date(monday);
  sunday.setUTCDate(monday.getUTCDate() + 6);

  const formatUtcDate = (value: Date) =>
    `${value.getUTCFullYear()}-${pad(value.getUTCMonth() + 1)}-${pad(value.getUTCDate())}`;

  return {
    start: formatUtcDate(monday),
    end: formatUtcDate(sunday)
  };
};

export const getReportMonthRange = (monthValue: string): { start: string; end: string } => {
  const [year, month] = monthValue.split('-').map(Number);
  const lastDay = new Date(Date.UTC(year, month, 0)).getUTCDate();

  return {
    start: `${year}-${pad(month)}-01`,
    end: `${year}-${pad(month)}-${pad(lastDay)}`
  };
};
